import FinishGoodQualityInspectInbox from '@/models/FinishGoodQualityInspectInbox/FinishGoodQualityInspectInbox';

export default class FinishGoodQualityInspectInboxFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.controlCardId  = '';
		this.controlCardControlCardNumber = '';
		this.qtyBefore = '';
		this.qtyAfter = '';
		this.qtyPending = '';
		this.qtyNg = '';
		this.metodeQcId  = '';
		this.metodeQcName = '';
		this.partId  = '';
		this.partPartNumber = '';
		this.workOrderProcessDetailId  = '';
		this.workOrderProcessDetailPart = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			controlCardId : '0',
			controlCardControlCardNumber : '0',
			qtyBefore : '0',
			qtyAfter : '0',
			qtyPending : '0',
			qtyNg : '0',
			metodeQcId : '0',
			metodeQcName : '0',
			partId : '0',
			partPartNumber : '0',
			workOrderProcessDetailId : '0',
			workOrderProcessDetailPart : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}